__turbopack_context__.v({
  "card": "ParagraphTextStats-module__gba0ha__card",
  "cards": "ParagraphTextStats-module__gba0ha__cards",
  "desc": "ParagraphTextStats-module__gba0ha__desc",
  "eyebrow": "ParagraphTextStats-module__gba0ha__eyebrow",
  "inner": "ParagraphTextStats-module__gba0ha__inner",
  "label": "ParagraphTextStats-module__gba0ha__label",
  "section": "ParagraphTextStats-module__gba0ha__section",
  "text": "ParagraphTextStats-module__gba0ha__text",
  "title": "ParagraphTextStats-module__gba0ha__title",
  "value": "ParagraphTextStats-module__gba0ha__value",
});
